import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const UserPlatformVoicePolicyDropdown = ({
    setPlatformUser,
    errors,
    darkMode,
    voicePolicies,
    platform,
    platformIndex,
}) => {
    const userProfiles = platform?.userProfiles || [];
    const handleSelectChange = (item) => {
        setPlatformUser((prev) => {
            const newPlatformUsers = [...prev];
            newPlatformUsers[platformIndex] = {
                ...platform,
                userProfiles: [
                    {
                        ...userProfiles[0],
                        msVoicePolicyID: item.id,
                    },
                ],
            };
            return newPlatformUsers;
        });
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.voicePolicy}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Voice Policy
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id="voicePolicy"
                    name="voicePolicy"
                    shownValue="name"
                    currentId={platform?.userProfiles[0]?.msVoicePolicyID}
                    handleSelectChange={handleSelectChange}
                    darkMode={darkMode}
                    data={voicePolicies}
                    data-walkthroughid={
                        walkthroughIds.edit.ufVoicePolicyDropdown
                    }
                    validate={() => {
                        if (
                            platform?.userProfiles[0]?.msVoicePolicyID ===
                            undefined
                        ) {
                            return 'Please select a Voice Policy';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Voice Policy"
                        ariaLabel="users-voice-policy-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UserPlatformVoicePolicyDropdown;
